import { CircularProgress } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Label, SecondaryTitle, Space } from '@/components';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      width: '320px',
      height: '224px',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      margin: 'auto',
      backgroundColor: theme.colors.primaryBackground,
      color: theme.colors.primary,
      borderRadius: '12px',
      textAlign: 'center',
      padding: theme.spacing(2),
    },
    circular: {
      color: theme.colors.secondaryContrast,
    },
  }),
);

export interface ProgressBoxProps {
  'data-test'?: string;
  operation: React.ReactNode;
}

const ProgressBox: React.FC<ProgressBoxProps> = ({ operation, 'data-test': dataTest }) => {
  const classes = useStyles();

  return (
    <Space direction="vertical" size={3} className={classes.mainContainer}>
      <CircularProgress color="inherit" className={classes.circular} />
      <Space direction="vertical" style={{ alignItems: 'center' }}>
        <SecondaryTitle data-test={dataTest && `${dataTest}-title`}>
          <FormattedMessage id="common.backdrop.title" />
        </SecondaryTitle>
        <Label data-test={dataTest && `${dataTest}-message`}>{operation}</Label>
      </Space>
    </Space>
  );
};

export default ProgressBox;
